export const MIN_ADULT_COUNT = 1;
export const MAX_ADULT_COUNT = 6;
export const DEFAULT_ADULT_COUNT = 2;
export const MIN_CHILDREN_COUNT = 0;
export const MAX_CHILDREN_COUNT = 3;
export const DEFAULT_CHILDREN_COUNT = 0;

export const API_URL = '/api/trip';
